import { useEffect } from 'react';
import {
  executeRequest,
  responseProperties,
} from 'src/common/hooks/widgets/fetchData';

export interface emailVariablesProperties {
  variables: {
    emailTo: string;
    emailSubject: string;
    hostingService: string;
  };
}

export interface emailProperties {
  emailFrom?: string;
  emailTo: string;
  emailCC?: string;
  emailSubject?: string;
  emailText: string;
  html?: string;
  attachments?: [
    {
      filename: string;
      path: string;
    },
  ];
}

/**
 *
 */
const emailNotification = (
  feedback: string,
  setResponse: React.Dispatch<React.SetStateAction<responseProperties>>,
  vars: emailVariablesProperties,
) => {
  useEffect(() => {
    if (vars.variables) {
      const body: any = {
        emailTo: vars.variables.emailTo,
        emailText: feedback,
        emailSubject: vars.variables.emailSubject,
      };
      if (
        vars.variables.emailTo.length === 0 ||
        vars.variables.emailSubject.length === 0 ||
        feedback.length === 0
      ) {
        console.error(`Bucket JSON did not provide email properties`);
        setResponse({
          status: 500,
          message: 'Email variables undefined',
        });
        return;
      }
      executeRequest(
        `${vars.variables.hostingService}/email`,
        body,
        'POST',
      ).then((emailResponse) => {
        setResponse(emailResponse);
      });
    }
  }, [feedback, vars]);
};

export default emailNotification;
